import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LetDirective, PushPipe } from '@ngrx/component';
import { AddressAutocompleteComponent } from './address-autocomplete/address-autocomplete.component';
import { BROWSER_GLOBALS_PROVIDERS } from './browser-globals';
import { GoogleMaps } from './google-maps.service';
import { LoadMapsComponent } from './load-maps/load-maps.component';
import { MapsConfig } from './maps-config';

@NgModule({
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    LetDirective,
    PushPipe,
    ReactiveFormsModule,
    GoogleMapsModule,
  ],
  declarations: [LoadMapsComponent, AddressAutocompleteComponent],
  exports: [AddressAutocompleteComponent, LoadMapsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GoogleMapsAddressModule {
  static forRoot(gmapsConfig: MapsConfig): ModuleWithProviders<GoogleMapsAddressModule> {
    return {
      ngModule: GoogleMapsAddressModule,
      providers: [
        GoogleMaps,
        ...BROWSER_GLOBALS_PROVIDERS,
        {
          provide: MapsConfig,
          useValue: gmapsConfig,
        },
      ],
    };
  }
}
